import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, Input, OnChanges, Output, SimpleChanges,EventEmitter, ViewChild } from '@angular/core';
import { AppEventService, DataCacheService, DiagramSelectionService, PipeworkComponent,Quantity, RestDataService, UtilsService } from 'pumpcalc-core';
import {environment} from '../../environments/environment';
import { Errors, ValidationService } from '../validation.service';

@Component({
  selector: 'app-booster-form',
  templateUrl: './booster-form.component.html',
  styleUrls: ['./booster-form.component.css']
})
export class BoosterFormComponent implements OnChanges {

  @Input() boosterLayer;
  @Input() boosterNumber;
  @Input() errors;
  @Output() boosterChange:EventEmitter<any>=new EventEmitter();
  @ViewChild('pipework') pipework:PipeworkComponent;
  quantity=Quantity;
  private lastSelection;
  error=Errors;  
  limitRotationalSpeed=false;

  constructor(private appEventService:AppEventService,
              private utilsService:UtilsService,
              private diagramSelectionService:DiagramSelectionService,
              private restDataService:RestDataService,
              private validationService:ValidationService,
              private dataCacheService:DataCacheService
              ) {
    this.diagramSelectionService.diagramElementSelected.subscribe(selector=>{
      this.lastSelection=selector==this.lastSelection?this.lastSelection:this.handleDiagramPipeSelection(selector);
    })
    this.appEventService.events.subscribe(event=>{
      if(event.name=="SELECTION" && event.context=="Booster" && event.parameters.boosterNumber==this.boosterNumber){        
        this.setBoosterSelection(event.data.id);
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {    
    this.boosterLayer = this.utilsService.clone(this.boosterLayer);
    this.boosterLayer.boosterDetails.changeInitialFrequency=this.boosterLayer.boosterDetails.initialFrequency!=-1;       
    this.boosterLayer.boosterDetails.limitRotationalSpeed=this.boosterLayer.boosterDetails.limitRotationalSpeed || this.boosterLayer.boosterDetails.userMaximumFrequency>0;        
  }

  changeBooster(){
    this.appEventService.emit({name:"OPEN_LIST",context:"Booster",parameters:{boosterNumber:this.boosterNumber}})
  }

  changePipework($event){
    if(this.boosterLayer.pipework.length <1){this.boosterLayer.pipework[0]={"shapeSection": 0,"length": 0.1,"xDim1": 0,"xDim2": 0,"parallel": 1,"bends": 0,"isFlexible": false,"xdim1": 0,"xdim2": 0,id:0,section:"Circular",selected:false}};
    this.announceChange();
  }

  announceChange(){
    this.boosterChange.emit({number:this.boosterNumber,booster:this.boosterLayer});
  }

  clickPipe(pipe){
    this.lastSelection='pw#'+this.boosterNumber+'#p#'+pipe.id;
    this.diagramSelectionService.selectElementId(this.lastSelection);
  }

  handleDiagramPipeSelection(selector):string{
    this.lastSelection=selector;
    let path = selector.split('#');
    if(path[0]=='pw' && path[1] == this.boosterNumber){
      this.pipework.selectRowToEdit(Number(path[3]));
      return selector;
    }
    return null;
  }

  setBoosterSelection(boosterId:string){
    this.restDataService.get(this.restDataService.addIdToURL(boosterId,environment.boosterDetailsURL)).subscribe((boosterDetails:any)=>{
      this.dataCacheService.put(boosterDetails.id,boosterDetails);
      this.boosterLayer.hasUserBooster=false;
      this.boosterLayer.boosterDetails=boosterDetails;
      this.boosterLayer.boosterId=boosterDetails.id;
      this.boosterLayer.boosterName=boosterDetails.name;
      this.boosterLayer.boosterDetails.changeInitialFrequency=this.boosterLayer.boosterDetails.initialFrequency!=-1;
      this.announceChange();
    })
  }

  getError(path:string[]):string{
    return this.validationService.getError(this.errors,path);
  }

  toggleChangeInitialFrequency(){
    this.boosterLayer.boosterDetails.initialFrequency=this.boosterLayer.boosterDetails.initialFrequency==-1?0:-1;
    this.announceChange();
  }

  toggleChangeRotationalSpeed(){    
    if(!this.boosterLayer.boosterDetails.limitRotationalSpeed){
      this.boosterLayer.boosterDetails.userMaximumFrequency=0;      
    }    
    this.announceChange();
  }

}
